import {NavbarMenu} from './components/NavbarMenu'

$(function () {
  const $headerBottom = $('#headerBottom'),
    $window = $(window);

  //disable bootstrap default toggle as far as we are using our toggle
  $("#mobile-menu-toggle").click(function (ev) {
    ev.stopPropagation();
    $(document.body).toggleClass("mobile-menu-activated");
  });


  new NavbarMenu($headerBottom);

  $window.on('hashchange', function (ev) {
    ev.preventDefault();
    return false;
  });

  // Disable jpax for links which are under #contact-form
  $('#contact-form').find('.checkbox-message a').attr('data-pjax', '0');

  $('#sidebar a').click(function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      let scrollTop = $(hash).offset().top;

      if ($window.outerWidth() < 992) {
        scrollTop -= $headerBottom.outerHeight() + 16;
      }
      $('html, body').animate({
        scrollTop: scrollTop
      }, 800, function () {

        // Add hash (#) to URL when done scrolling (default click behavior)
        if (location.hash !== hash) {
          history.pushState(null, null, hash);
        }
      });
    }  // End if
  });

  $('.content-linked-page-teaser-big').click(function () {
    var $this = $(this),
      $a = $this.find('.teaser-link > a');
    window.location.href = $a.attr('href');
  });

  // $('#playVideo').click(function () {
  //   let $this = $(this);
  //   $this.closest('.content-video_section').addClass('video-playing').find('video')[0].play();
  // });

  //Faq content text animation

  // $('.faq-close>a').click(function (ev) {
  //   ev.preventDefault();
  //   let $this = $(this);
  //   $this.closest('.content-content_text-faq').toggleClass('opened');
  //   $('#' + $this.attr('data-target')).slideToggle(300);
  // });

  //New Faq content text animation
  $('.faq-headline').click(function (ev) {
    ev.preventDefault();
    let $this = $(this).parent().parent();
    $this.closest('.content-content_text-faq').toggleClass('opened');
    $('#' + $this.find('a').attr('data-target')).slideToggle(300);
  });
  $('.faq-close').click(function (ev) {
    ev.preventDefault();
    let $this = $(this);
    $this.closest('.content-content_text-faq').toggleClass('opened');
    $('#' + $this.find('a').attr('data-target')).slideToggle(300);
  });


  $('#searchBtn').click(function () {
    let $this = $(this);
    $this.closest('.form-search').toggleClass('opened');
    $this.closest('.form-search').find('input')[0].focus();

  });
  var $img = $('.xmlblock img');
  if ($img.hasClass('video-play-icon')) {
    $img.removeClass('video-play-icon');
    $img.parent('picture').addClass('video-play-icon');
    $img.parent('picture').attr('data-toggle', 'modal');
    $img.parent('picture').attr('data-target', '#educationalVideoModal');
  }

  var $educationalVideo = $("#educationalVideoModal");
  $educationalVideo.on('shown.bs.modal', function () {
    $(this).find('.educational-video')[0].play();
  });

  $educationalVideo.on('hide.bs.modal', function () {
    $(this).find('.educational-video')[0].pause();
  });
  $('.centered-video-wrapper').click(function (ev) {
    let $this = $(this);
    let $video = $this.find('.centered-video');
    $video[0].onplay = () => {
      $this.addClass().addClass('hide-banner');
      $video.attr('controls', true);
    };
    $video[0].play();
  });

});

